export default __webpack_public_path__ + "static/quote_05_reliability_resilience-da251463d2660dc4858c2539525e743b.jpg";